import { useLocation, useNavigate, useParams } from 'react-router';
import { Routes } from '../../app/routes';
import { ItemView } from './ItemView';

/** One item on its own page: the deep link `/items/:id`, as in the mobile app. */
export function ItemPage() {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  // 'default' is the entry the app started on: going back from it would leave the app.
  const cameFromApp = useLocation().key !== 'default';
  return (
    <ItemView
      key={id}
      itemId={id}
      layout="page"
      onFinished={() => void (cameFromApp ? navigate(-1) : navigate(Routes.inbox))}
    />
  );
}
